import { nanoid } from 'nanoid';
import { useEffect, useRef } from 'react';
import { useMap } from 'react-map-gl/mapbox';
import { subscribe, useSnapshot } from 'valtio';
import { EditorMode } from '~/common/types';
import EditorSurfaceCanvas from '~/components2/Map/canvas/EditorSurface';
import { mapState } from '~/components2/Map/Map';
import store from '../drawStore';

export default function EditorSurface() {
  const map = useMap();
  const container = useRef<HTMLDivElement>(null);
  const { editorMode } = useSnapshot(store) as typeof store;

  // biome-ignore lint/correctness/useExhaustiveDependencies: surface is (re)created when the editor mode changes
  useEffect(() => {
    if (container.current && map.current && editorMode !== EditorMode.None) {
      const surface = new EditorSurfaceCanvas({
        id: `sub-geometry-editor-surface-${nanoid()}`,
        container: container.current,
        map: map.current.getMap(),
        store,
      });
      const unsubscribe = subscribe(mapState, () => surface.refreshScreenCoords());
      return () => {
        unsubscribe();
        surface.destroy();
      };
    }
  }, [editorMode]);

  if (!map.current || editorMode === EditorMode.None) return null;

  return <div ref={container} style={{ cursor: '-moz-grab' }} className="absolute left-0 top-0" />;
}
